import request from 'api/request';

export default function createQuestionRoute({ courseId, field, ...data }) {
  return request({
    url: `/courses/${courseId}/${field}`,
    method: 'POST',
    data,
  });
}
